import styled from 'styled-components';

export const PageWrapper = styled.div`
  background-color: #f8fafc;
  display: flex;
  flex-direction: column;
  padding: 15px 20px;
`;

export const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 3rem 1rem;
  max-width: 56rem;
  box-sizing: border-box;
`;

export const Header = styled.div`
  text-align: center;
  margin-bottom: 3rem;
`;

export const Title = styled.h1`
  font-size: 2.25rem;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 1rem;
`;

export const Subtitle = styled.p`
  font-size: 1.125rem;
  color: #4b5563;
`;

/**
 * 主卡片容器 — 对应 DESIGN.md store-utility-card:
 *   border-radius: 18px  ({rounded.lg})
 *   padding:       24px  ({spacing.lg})
 */
export const Card = styled.div`
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 18px;
  padding: 24px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
`;

/** 卡片内每条成员/选项行，用 border-bottom 作分隔线 */
export const MemberRow = styled.div`
  padding-bottom: 1rem;
  border-bottom: 1px solid #e5e7eb;
  &:last-of-type {
    border-bottom: none;
    padding-bottom: 0;
  }
`;

export const FinishWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 2rem;
`;

export const Footer = styled.div`
  margin-top: 2rem;
  text-align: center;
`;

export const FooterText = styled.p`
  font-size: 0.875rem;
  color: #6b7280;
`;

export const FooterLink = styled.a`
  color: #7c3aed;
  font-weight: 500;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;
